import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from "vuex-persist";

Vue.use(Vuex);

const vuexLocal = new VuexPersist({
  key: process.env.VUE_APP_PROJECT_KEY,
  storage: window.localStorage,
  modules: ["token", "user"],
});

export default new Vuex.Store({
  state: {
    token: "",
    user: null,
  },

  getters: {
    authenticated: ({ token, user }) => !!token && !!user,
    token: ({ token }) => token,
    user: ({ user }) => user,
  },

  mutations: {
    SET_TOKEN(state, payload) {
      state.token = payload;
    },

    SET_USER(state, payload) {
      state.user = payload;
    },
  },

  actions: {
    setToken({ commit }, payload) {
      commit("SET_TOKEN", payload);
    },

    setUser({ commit }, payload) {
      commit("SET_USER", payload);
    },

    setSignIn({ dispatch }, payload) {
      dispatch("setToken", payload.token);
      dispatch("setUser", payload.user);
    },

    setSignOut({ dispatch }) {
      dispatch("setToken", "");
      dispatch("setUser", null);
    },
  },

  modules: {},

  plugins: [vuexLocal.plugin],
});
